module.exports = __webpack_public_path__ + "img/Shkodran Mustafi.1f9e5411.png";